import { render, staticRenderFns } from "./FeishuAlertPolicyDialog.vue?vue&type=template&id=4ef8f004&scoped=true"
import script from "./FeishuAlertPolicyDialog.vue?vue&type=script&lang=js"
export * from "./FeishuAlertPolicyDialog.vue?vue&type=script&lang=js"
import style0 from "./FeishuAlertPolicyDialog.vue?vue&type=style&index=0&id=4ef8f004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8f004",
  null
  
)

export default component.exports